import React from 'react';

import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

import './CreateThemeTemplateDropdown.scss';

const propTypes = {
  onCreateBlankTheme: PropTypes.func.isRequired,
  onCreateWebsiteTheme: PropTypes.func.isRequired,
};

function CreateThemeTemplateDropdown({ onCreateBlankTheme, onCreateWebsiteTheme }) {
  const options = [
    { key: 'blank', text: 'Create Blank Theme', value: 'blank', onClick: onCreateBlankTheme },
    {
      key: 'website',
      text: 'Create From Website',
      value: 'website',
      onClick: onCreateWebsiteTheme,
    },
  ];

  return (
    <Dropdown
      className="create-theme-template-dropdown icon"
      button
      labeled
      floating
      icon="file code outline"
      options={options}
      text="Create Template"
    />
  );
}

CreateThemeTemplateDropdown.propTypes = propTypes;

export default CreateThemeTemplateDropdown;
